const tarotIcons = {
    Dove: 'fa fa-dove',
    Hound: 'fa fa-paw',
    Magician: 'fa fa-magic',
    'Balanced Scales': 'fa fa-balance-scale',
    Death: 'fa fa-skull',
    Chains: 'fa fa-link',
    Wood: 'fa fa-tree',
    Brains: 'fa fa-brain',
    Brimstone: 'fa fa-fire',
    Labourer: 'fa fa-tools',
    Shadow: 'fa fa-ghost',
};

export function iconFor(tarotName) {
    return tarotIcons[tarotName] || 'fa fa-question-circle';
}

// Mirrors GuideTarotIcons.SlugFor so a card and its detail page pick up the same
// per-card colour class.
export function slugFor(tarotName) {
    if (!tarotName) return '';
    return tarotName.toLowerCase().split(' ').join('-');
}

export default tarotIcons;
